import { UserInitials } from 'components/UserInitials/UserInitials';
import { useTunnusContext } from 'contexts/TunnusContext';
import { FC } from 'react';
import styles from './Profile.module.scss';
import { Link } from 'components/Link';
import { useUILanguage } from 'hooks/useUILanguage';
import { useTranslation } from 'hooks/useTranslation';
import { isTestEnvironment } from 'utils/environment';

const YLE_TUNNUS_SETTINGS_URL = {
  fi: isTestEnvironment()
    ? 'https://tunnus-test.yle.fi/omat-tiedot'
    : 'https://tunnus.yle.fi/omat-tiedot',
  sv: isTestEnvironment()
    ? 'https://tunnus-test.yle.fi/mina-uppgifter'
    : 'https://tunnus.yle.fi/mina-uppgifter',
} as const;

export const Profile: FC = () => {
  const { user: userInformation } = useTunnusContext();
  const language = useUILanguage();
  const t = useTranslation();

  if (!userInformation) return null;

  return (
    <div className={styles.root}>
      <div className={styles.leftSide}>
        <UserInitials size="md" />
      </div>
      <div className={styles.rightSide}>
        <div className={styles.name}>
          {userInformation.displayName || userInformation.nick}
        </div>
        <div className={styles.email}>{userInformation.username}</div>
        <Link
          className={styles.tunnusLink}
          pointer={{
            uri: YLE_TUNNUS_SETTINGS_URL[language],
          }}
        >
          {t('yleTunnusSettings')}
        </Link>
      </div>
    </div>
  );
};
